import "../../../../content/projects/pizza-hut/pizza-hut.css";
import * as React from 'react';
export default {
  React
};